import { RequestService } from '../../../../common/services/RequestService';
import { UPDATE_TEMPLATE } from '../constants';
import { adjustTemplateById, adjustTemplateSend } from './adjustTemplateById';

export const updateTemplateRequest = async (profileId, data) => {
  const response = await RequestService.put(
    UPDATE_TEMPLATE,
    adjustTemplateSend(profileId, data)
  );
  return response.data && adjustTemplateById(response.data);
};
